import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed877bd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "list-title" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "num" }

import { getERC20s } from "@/api/_common";
import Title from "@/components/SecondaryTitle.vue";
import List from "@/components/List.vue";
import HelperTools from "@/utils/helper";
import { ref, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { fromWei } from "@/utils/use-format";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pageSize = 10;

const route = useRoute();
const router = useRouter();

const elements = reactive({
  Contracts: [],
  TotalCount: 0,
});
const rowData = ref([
  {
    prop: "#",
    label: "contracts.rank",
    method: (row) => row.Rank,
  },
  {
    prop: "TokenNameSymbol",
    label: "contracts.tokenname",
    method: (row) => `${row.Name} (${row.Symbol})`,
  },
  {
    prop: "Transactions",
    label: "contracts.txs",
    method: (row) => row.TransferNum,
  },
  {
    prop: "Addresses",
    label: "contracts.address",
    method: (row) => row.AddressNum,
  },
  {
    prop: "Supply",
    label: "contracts.supply",
    method: (row) => fromWei(row.TotalSupply),
  },
  {
    prop: "Time",
    label: "contracts.time",
    method: (row) => HelperTools.getTransDate(row.Time),
  },
]);

const currentPage = ref(0);

const getContracts = async (newPage: number) => {
  const res = await getERC20s({
    PageNo: newPage,
    PageSize: pageSize,
  }).catch(() => console.error("Error fetching erc-20"));
  if (res) {
    elements.Contracts = res.Contracts;
    elements.TotalCount = res.TotalCount;
    for (let i = 0; i < pageSize; i++) {
      if (elements && elements.Contracts[i]) {
        elements.Contracts[i].Rank = pageSize * newPage + i + 1;
      }
    }
  }
};
const handleCurrentChange = async (newPage: number) => {
  await router.replace({
    query: {
      page: newPage,
    },
  });
  await getContracts(newPage - 1);
  currentPage.value = newPage;
};
const handle = (row) => {
  router.push({
    name: "ContractDetail",
    params: { Contract: row.Contract },
  });
};

const load = () => {
  const page: number = !route.query.page ? 1 : Number(route.query.page);
  handleCurrentChange(page);
};
load();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Title, {
        title: _ctx.$t('contracts.erc20')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("contracts.totalof")), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(HelperTools).toFinancialVal(_unref(elements).TotalCount)), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("contracts.block")), 1)
      ])
    ]),
    _createVNode(List, {
      data: _unref(elements).Contracts,
      handleCurrentChange: handleCurrentChange,
      handle: handle,
      rowDatas: rowData.value,
      total: _unref(elements).TotalCount,
      firstColumnWidth: "80",
      secondColumnWidth: "250",
      thirdColumnWidth: "148",
      fourthColumnWidth: "146",
      fifthColumnWidth: "146",
      sixthColumnWidth: "250",
      "current-page": currentPage.value
    }, null, 8, ["data", "rowDatas", "total", "current-page"])
  ]))
}
}

})